import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        /* FIX: Using h-screen (or min-h-screen) with a calculation 
           to subtract the Navbar height (80px mobile / 90px desktop).
        */
        <section className="relative w-full h-[calc(100vh-80px)] md:h-[calc(100vh-90px)] mt-[80px] md:mt-[90px] flex items-center bg-brand-cream overflow-hidden">

            {/* Background Image & Gradients */}
            <div className="absolute inset-0 z-0">
                <img
                    src="/hero-bg-pattern.jpg"
                    alt="Premium Packaging Background"
                    className="w-full h-full object-cover object-center opacity-60 md:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-brand-cream via-brand-cream/90 to-transparent hidden lg:block"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-brand-cream/10 via-brand-cream/40 to-brand-cream/80 lg:hidden"></div>
            </div>

            {/* CONTENT */}
            <div className="container-x relative z-10 w-full flex flex-col justify-center">

                <div className="w-full">
                    {/* Sub-heading */}
                    <div className="inline-flex flex-col">
                        <span className="h-[1.5px] w-full bg-brand-gold/80 mb-1.5"></span>
                        <p className="text-[11px] md:text-sm uppercase tracking-[0.25em] text-brand-gold font-bold leading-none">
                            Est. 1990 · Mumbai, India
                        </p>
                    </div>

                    {/* Heading */}
                    <h1 className="font-serif mt-6 md:mt-8 text-[36px] sm:text-[50px] md:text-[65px] lg:text-[80px] xl:text-[95px] leading-[1.0] tracking-tight text-brand-dark max-w-6xl">
                        <span className="block">Premium Packaging</span>
                        <span className="block mt-1 md:mt-2">
                            <span className="italic text-brand-brown">Solutions</span>
                            <span className="mx-2 md:mx-4 font-light">for</span>
                            <span className="relative inline-block">
                                Everything
                                <span className="absolute -bottom-1 md:-bottom-2 left-0 w-full h-[1.5px] md:h-[2.5px] bg-brand-gold/70"></span>
                            </span>
                        </span>
                    </h1>

                    {/* Description */}
                    <p className="mt-6 md:mt-10 text-sm md:text-lg text-gray-700 max-w-2xl leading-relaxed">
                        Crafting elegant boxes for sweets, gifts & brands since 1990 — three
                        generations of family craftsmanship, refined to export-quality standards.
                    </p>

                    {/* Buttons */}
                    <div className="mt-8 md:mt-10 flex flex-wrap gap-4">
                        <Link
                            to="/products"
                            className="bg-brand-brown text-white px-8 md:px-10 py-3 md:py-4 rounded-sm flex items-center gap-3 hover:bg-[#6b2a21] transition-colors text-[11px] md:text-xs font-bold uppercase tracking-widest shadow-lg shadow-brand-brown/10"
                        >
                            View Products
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M5 12h14"></path>
                                <path d="m12 5 7 7-7 7"></path>
                            </svg>
                        </Link>

                        <Link
                            to="/contact"
                            className="backdrop-blur-sm border border-brand-gold/50 text-brand-dark px-8 md:px-10 py-3 md:py-4 rounded-sm hover:bg-brand-gold hover:text-white transition-all text-[11px] md:text-xs font-bold uppercase tracking-widest"
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default Hero;